var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "activator" }, slot: "activator" },
            [
              _c(
                "v-tooltip",
                { attrs: { right: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "elevation-10",
                      attrs: {
                        slot: "activator",
                        fab: "",
                        large: "",
                        color: "primary darken-1",
                        dark: ""
                      },
                      slot: "activator"
                    },
                    [_c("v-icon", [_vm._v("add")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", [_vm._v("Add a new event")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.formTitle))
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.layouts,
                                  "item-text": "name",
                                  "item-value": "id",
                                  label: "Layout *",
                                  name: "layout",
                                  "prepend-icon": "view_column",
                                  auto: "",
                                  disabled: _vm.editedIndex !== -1,
                                  "error-messages": _vm.form.errors.has(
                                    "layout"
                                  )
                                    ? _vm.form.errors.get("layout")
                                    : []
                                },
                                on: {
                                  change: function($event) {
                                    _vm.form.errors.clear("layout")
                                  }
                                },
                                model: {
                                  value: _vm.editedItem.layout.id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem.layout, "id", $$v)
                                  },
                                  expression: "editedItem.layout.id"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "prepend-icon": "event_note",
                                  label: "Name *",
                                  name: "name",
                                  "error-messages": _vm.form.errors.has("name")
                                    ? _vm.form.errors.get("name")
                                    : []
                                },
                                on: {
                                  keypress: function($event) {
                                    _vm.form.errors.clear("name")
                                  }
                                },
                                model: {
                                  value: _vm.editedItem.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem, "name", $$v)
                                  },
                                  expression: "editedItem.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  ref: "startDateMenu",
                                  attrs: {
                                    lazy: "",
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "full-width": "",
                                    "nudge-right": 40,
                                    "min-width": "290px",
                                    "return-value": _vm.editedItem.startDate
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      _vm.$set(
                                        _vm.editedItem,
                                        "startDate",
                                        $event
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.startDateMenu,
                                    callback: function($$v) {
                                      _vm.startDateMenu = $$v
                                    },
                                    expression: "startDateMenu"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      slot: "activator",
                                      label: "Start Date *",
                                      "prepend-icon": "event",
                                      "error-messages": _vm.form.errors.has(
                                        "startDate"
                                      )
                                        ? _vm.form.errors.get("startDate")
                                        : [],
                                      readonly: ""
                                    },
                                    on: {
                                      keypress: function($event) {
                                        _vm.form.errors.clear("startDate")
                                      }
                                    },
                                    slot: "activator",
                                    model: {
                                      value: _vm.editedItem.startDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedItem,
                                          "startDate",
                                          $$v
                                        )
                                      },
                                      expression: "editedItem.startDate"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { "no-title": "", scrollable: "" },
                                      model: {
                                        value: _vm.editedItem.startDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editedItem,
                                            "startDate",
                                            $$v
                                          )
                                        },
                                        expression: "editedItem.startDate"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.startDateMenu = false
                                            }
                                          }
                                        },
                                        [_vm._v("Cancel")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.$refs.startDateMenu.save(
                                                _vm.editedItem.startDate
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("OK")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  ref: "startTimeMenu",
                                  attrs: {
                                    lazy: "",
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "full-width": "",
                                    "nudge-right": 40,
                                    "max-width": "290px",
                                    "min-width": "290px",
                                    "return-value": _vm.editedItem.startTime
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      _vm.$set(
                                        _vm.editedItem,
                                        "startTime",
                                        $event
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.startTimeMenu,
                                    callback: function($$v) {
                                      _vm.startTimeMenu = $$v
                                    },
                                    expression: "startTimeMenu"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      slot: "activator",
                                      label: "Start Time *",
                                      "prepend-icon": "access_time",
                                      "error-messages": _vm.form.errors.has(
                                        "startDate"
                                      )
                                        ? _vm.form.errors.get("startDate")
                                        : [],
                                      readonly: ""
                                    },
                                    on: {
                                      keypress: function($event) {
                                        _vm.form.errors.clear("startDate")
                                      }
                                    },
                                    slot: "activator",
                                    model: {
                                      value: _vm.editedItem.startTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedItem,
                                          "startTime",
                                          $$v
                                        )
                                      },
                                      expression: "editedItem.startTime"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-time-picker", {
                                    on: {
                                      change: function($event) {
                                        _vm.$refs.startTimeMenu.save(
                                          _vm.editedItem.startTime
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.editedItem.startTime,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.editedItem,
                                          "startTime",
                                          $$v
                                        )
                                      },
                                      expression: "editedItem.startTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  ref: "endDateMenu",
                                  attrs: {
                                    lazy: "",
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "full-width": "",
                                    "nudge-right": 40,
                                    "min-width": "290px",
                                    "return-value": _vm.editedItem.endDate
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      _vm.$set(
                                        _vm.editedItem,
                                        "endDate",
                                        $event
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.endDateMenu,
                                    callback: function($$v) {
                                      _vm.endDateMenu = $$v
                                    },
                                    expression: "endDateMenu"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      slot: "activator",
                                      label: "End Date *",
                                      "prepend-icon": "event",
                                      "error-messages": _vm.form.errors.has(
                                        "endDate"
                                      )
                                        ? _vm.form.errors.get("endDate")
                                        : [],
                                      readonly: ""
                                    },
                                    on: {
                                      keypress: function($event) {
                                        _vm.form.errors.clear("endDate")
                                      }
                                    },
                                    slot: "activator",
                                    model: {
                                      value: _vm.editedItem.endDate,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editedItem, "endDate", $$v)
                                      },
                                      expression: "editedItem.endDate"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: { "no-title": "", scrollable: "" },
                                      model: {
                                        value: _vm.editedItem.endDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.editedItem,
                                            "endDate",
                                            $$v
                                          )
                                        },
                                        expression: "editedItem.endDate"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.endDateMenu = false
                                            }
                                          }
                                        },
                                        [_vm._v("Cancel")]
                                      ),
                                      _vm._v(" "),
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { flat: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.$refs.endDateMenu.save(
                                                _vm.editedItem.endDate
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("OK")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  ref: "endTimeMenu",
                                  attrs: {
                                    lazy: "",
                                    "close-on-content-click": false,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "full-width": "",
                                    "nudge-right": 40,
                                    "max-width": "290px",
                                    "min-width": "290px",
                                    "return-value": _vm.editedItem.endTime
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      _vm.$set(
                                        _vm.editedItem,
                                        "endTime",
                                        $event
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.endTimeMenu,
                                    callback: function($$v) {
                                      _vm.endTimeMenu = $$v
                                    },
                                    expression: "endTimeMenu"
                                  }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      slot: "activator",
                                      label: "End Time *",
                                      "prepend-icon": "access_time",
                                      "error-messages": _vm.form.errors.has(
                                        "endDate"
                                      )
                                        ? _vm.form.errors.get("endDate")
                                        : [],
                                      readonly: ""
                                    },
                                    on: {
                                      keypress: function($event) {
                                        _vm.form.errors.clear("endDate")
                                      }
                                    },
                                    slot: "activator",
                                    model: {
                                      value: _vm.editedItem.endTime,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editedItem, "endTime", $$v)
                                      },
                                      expression: "editedItem.endTime"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("v-time-picker", {
                                    on: {
                                      change: function($event) {
                                        _vm.$refs.endTimeMenu.save(
                                          _vm.editedItem.endTime
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.editedItem.endTime,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editedItem, "endTime", $$v)
                                      },
                                      expression: "editedItem.endTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary darken-1", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.close("edit")
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "", dark: "" } }, [
                        _vm._v("arrow_back")
                      ]),
                      _vm._v("\n          Cancel\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary darken-1",
                        loading: _vm.formLoading
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save($event)
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "", dark: "" } }, [
                        _vm._v("save")
                      ]),
                      _vm._v("\n          Save\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "1200" },
          model: {
            value: _vm.bookingDialog,
            callback: function($$v) {
              _vm.bookingDialog = $$v
            },
            expression: "bookingDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { card: "", dark: "", color: "primary" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.bookingDialog = false
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.editedItem.layout.name) +
                        "\n        "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text"),
              _vm._v(" "),
              _c("v-card-actions")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "elevation-5" },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [_vm._v("Events")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  "append-icon": "search",
                  label: "Search",
                  "single-line": "",
                  "hide-details": ""
                },
                on: {
                  keyup: function($event) {
                    if (
                      !("button" in $event) &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchEvents($event)
                  }
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-data-table",
            {
              attrs: {
                headers: _vm.headers,
                items: _vm.events,
                pagination: _vm.pagination,
                "rows-per-page-items": _vm.rowsPerPageItems,
                "total-items": _vm.totalEvents,
                loading: _vm.tableLoading,
                "must-sort": true
              },
              on: {
                "update:pagination": function($event) {
                  _vm.pagination = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "items",
                  fn: function(props) {
                    return [
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { nowrap: "" }
                        },
                        [_vm._v(_vm._s(props.item.id))]
                      ),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(props.item.name))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(props.item.type))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(props.item.startTime))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(props.item.endTime))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(props.item.layout.name))]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "justify-center layout px-0" },
                        [
                          props.item.layout.type === "CINEMA"
                            ? _c(
                                "v-layout",
                                { attrs: { row: "", "justify-center": "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-tooltip",
                                        { attrs: { top: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "mx-0",
                                              attrs: {
                                                slot: "activator",
                                                icon: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.editItem(
                                                    props.item,
                                                    "booking"
                                                  )
                                                }
                                              },
                                              slot: "activator"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "primary" } },
                                                [_vm._v("check_circle")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v("Booking preview")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            { attrs: { top: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0",
                                  attrs: { slot: "activator", icon: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.editItem(props.item, "edit")
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _c("v-icon", { attrs: { color: "teal" } }, [
                                    _vm._v("edit")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Edit")])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            { attrs: { top: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-0",
                                  attrs: { slot: "activator", icon: "" },
                                  on: {
                                    click: function($event) {
                                      _vm.deleteItem(props.item)
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _c("v-icon", { attrs: { color: "pink" } }, [
                                    _vm._v("delete")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Delete")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("v-progress-linear", {
                attrs: { slot: "progress", color: "blue", indeterminate: "" },
                slot: "progress"
              }),
              _vm._v(" "),
              _vm.noEventsFound
                ? _c(
                    "template",
                    { slot: "no-data" },
                    [
                      _c(
                        "v-alert",
                        {
                          attrs: {
                            value: true,
                            color: "error",
                            icon: "warning"
                          }
                        },
                        [
                          _vm._v(
                            "\n          Sorry, no events found in the database :(\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  attrs: {
                    slot: "no-results",
                    value: true,
                    color: "error",
                    icon: "warning"
                  },
                  slot: "no-results"
                },
                [
                  _vm._v(
                    '\n        Your search for "' +
                      _vm._s(_vm.search) +
                      '" found no results.\n      '
                  )
                ]
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: {
            timeout: _vm.snackbarTimeout,
            color: _vm.snackbarColor,
            top: ""
          },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackbarText) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function($event) {
                  _vm.snackbar = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d95278e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d95278e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/Events.vue
// module id = null
// module chunks = 